module.exports = __webpack_public_path__ + "img/icon1.76bca8ac.png";